var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_97028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.345.139l11.5 11a.501.501 0 01-.69.723L11.998 1.192.845 11.862a.5.5 0 01-.691-.723l11.5-11a.5.5 0 01.691 0zM20 12.5a.5.5 0 011 0v11a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5V16h-4v7.5a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-11a.5.5 0 011 0V23h5v-7.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V23h5V12.5z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_97028"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
SvgHome.displayName = 'Home';
export default SvgHome;